import React from 'react';
import { Link } from "react-router-dom";
import { useLocation } from "react-router";
import {
  ClientCompaniesQueryDocument,
  ClientCompany,
  useCompaniesMutationMutation
} from '../../generated/graphql';
import {useRecordModuleHistory} from '../../contexts/module-history-context';

import { useEffect } from 'react';
import { asMoney } from '../../utils';
import { FieldTableColumnProps } from '../../components/FieldTable/FieldTableTypes';
import {SideList} from "../../components/SideList";
import CompanySearch from "./search";

/*
function convertVariables(initialValues, values) {
  graphqlSetLookups(['clientCompanyGroup', 'clientType']);
  const differences = graphqlObjectToInput(initialValues, values);
  delete differences.contacts;
  console.log('differences', differences);
  return { input: differences };
}
*/

const Companies = () => {
  const location = useLocation();
  const combinedMutation = useCompaniesMutationMutation();
  const recordModuleHistory = useRecordModuleHistory();
  useEffect(() => {
    recordModuleHistory('companies');
  }, [recordModuleHistory, location]);
  //const query = useClientCompaniesQueryQuery();
  const columns: FieldTableColumnProps<ClientCompany>[] = [
    {
      accessor: 'accounts_company',
      header: 'Accounts Company',
      dataType: 'link',
      options: {
        getLink:({ field, row }) => {
          return ({
            pathname: '/companies/' + row.id,
            search: (location.search ? location.search : '')
          });
        }
      }
    },
    {
      accessor: 'sales_company',
      header: 'Sales Company',
      dataType: 'link',
      options: {
        getLink:({ field, row }) => {
          return ({
              pathname: '/companies/' + row.id,
              search: (location.search ? location.search : '')
            });
        }
      }
    },
    {
      accessor: 'accounts_account_code',
      header: 'Sage Code',
      dataType:'default'
    },
    {
      accessor: 'credit_limit',
      header: 'Credit Limit',
      className: 'column-right',
      dataType:'currency',
      readOnly:true,
      options: {
        renderViewer: ({ field }) => '£' + asMoney(field.value)
      }
    }, {
      accessor: 'accounts_address',
      header: 'Sales Address',
      dataType:'default'
    }, {
      accessor: 'accounts_postcode',
      header: 'Postcode',
      dataType:'default'
    }
  ];
  return <SideList searchForm={CompanySearch} query={ClientCompaniesQueryDocument} baseUrl="/companies/" label="Companies" columns={columns}
                   permission="companies"
className="companies"
                   deleteMutation={combinedMutation}
  />
/*
  return <SideEditorFull
    label="Companies"
    className=""
    getResults={(e) => e.getSalesTeams.data}
    query={clientCompaniesQuery}
    columns={columns}
    baseUrl="/companies/"
    permission="companies"
    combinedMutation={combinedMutation}
    searchForm={CompanySearch}
    editorProps={{
      combinedMutation: combinedMutation,
      // eslint-disable-next-line react/display-name
      form: (args) => <CompanyForm {...args} />,
      //combinedMutation:updateMutation,
      getQuery: clientCompanyExtra,
      getDataFromGraphql: (v) => {
        return v.clientCompany;
      },
      getIdFromResult: (v) => {
        console.log('getId', v);
        return v.updateClientCompanies[0].id;
      },
      convertVariables: convertVariables,
      validationSchema: schema,
      blankValues: blankCompany
    }}
  />*/
};

export default Companies;